import { CalendarIcon } from "lucide-react";
import { useSelector } from "react-redux";
import { stringToColor } from "src/lib/utils";
import { RootState } from "src/redux/store";
import { Button } from "src/shadcn/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "src/shadcn/ui/hover-card";

export function AvatarSection() {

    const user = useSelector((state: RootState) => state.user.employeeDetails)

    const color = stringToColor(user?.FM03_EmployeeName || "V")

    return (
        <HoverCard>
            <HoverCardTrigger asChild>
                <div style={{ background: color }} className=" cursor-pointer min-h-10 min-w-10 max-h-10 max-w-10 rounded-full text-white flex items-center justify-center font-bold border border-black">{user?.FM03_EmployeeName?.[0] || 'U'}</div>
            </HoverCardTrigger>
            <HoverCardContent className="w-80 ">
                <div className="flex justify-between space-x-4">
                    <div className="space-y-1">
                        <h4 className="text-sm font-semibold">{user.FM03_EmployeeName}</h4>
                        <p className="text-sm text-gray-500">
                            {user.FM03_MailID}
                        </p>
                        <div className=" text-xs">{user.sales_role}</div>
                        {/* <div className="flex items-center pt-2">
                <CalendarIcon className="mr-2 h-4 w-4 opacity-70" />{" "}
                <span className="text-xs text-muted-foreground">
                  Joined December 2021
                </span>
              </div> */}
                    </div>
                </div>
            </HoverCardContent>
        </HoverCard>
    )
}